class ScrollImageItem {
  constructor($el) {
    this.isFadein = false;
    this.$el = $el;
    this.hasScaleValue = false;
    if (this.$el.data('scroll-image') == 'scale') {
      this.hasScaleValue = true;
    }
  }
}

class ScrollImageManager {
  constructor() {
    this.windowHeight = window.innerHeight;
    this.items = [];
  }

  append($target) {
    this.items.push(new ScrollImageItem($target));
  }

  clear() {
    for (let i = 0; i < this.items.length; i++) {
      this.items[i] = null;
    }
    this.items = [];
  }

  onWindowResize() {
    this.windowHeight = window.innerHeight;
  }

  update(scrollTop) {
    for (let i = 0; i < this.items.length; i++) {
      const moveVolume =
        (1 -
          (this.items[i].$el.offset()['top'] - scrollTop) / this.windowHeight) *
        50;
      if (this.items[i].hasScaleValue) {
        this.items[i].$el.css(
          'transform',
          `translateY(${moveVolume - 30}px) scale(1.15)`
        );
      } else {
        this.items[i].$el.css('transform', `translateY(${moveVolume - 30}px)`);
      }
    }
  }
}

export default ScrollImageManager;
